import React from 'react'
import Bredcom from '../../Bradcom/Main'
import First from '../Menservisedeatils/First'
import Quickly from '../../Menhome/Quickly'

const ServiceDetails = () => {

  return (
    <>
        <Bredcom title={"Home"} subtitle={"Services"} common={"Finance Options"}/>
        <First/>
        <Quickly/>
    </>
  )
}

export default ServiceDetails